import { FC, ReactNode } from "react";
import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import {
  PersonOutlineOutlined,
  LockOutlined,
  ChevronRight,
} from "@mui/icons-material";

export type ProfileSubView = "dados" | "seguranca";

const ITEMS: { view: ProfileSubView; label: string; icon: ReactNode }[] = [
  { view: "dados", label: "Dados pessoais", icon: <PersonOutlineOutlined /> },
  { view: "seguranca", label: "Segurança", icon: <LockOutlined /> },
];

/** Menu do perfil no mobile: linhas que abrem cada sub-tela (padrão do handoff v4). */
const ProfileMobileMenu: FC<{ onSelect: (view: ProfileSubView) => void }> = ({ onSelect }) => {
  const theme = useTheme();

  return (
    <Box sx={{ border: `1px solid ${theme.palette.divider}`, borderRadius: "14px", overflow: "hidden", bgcolor: "background.paper" }}>
      {ITEMS.map((item, i) => (
        <ButtonBase
          key={item.view}
          onClick={() => onSelect(item.view)}
          aria-label={item.label}
          sx={{
            width: "100%",
            justifyContent: "flex-start",
            gap: 1.5,
            px: 2,
            py: 1.75,
            borderTop: i > 0 ? `1px solid ${theme.palette.divider}` : "none",
            "& svg": { fontSize: 20 },
          }}
        >
          <Box sx={{ color: "primary.main", display: "flex" }}>{item.icon}</Box>
          <Typography sx={{ flex: 1, textAlign: "left", fontSize: "14px", fontWeight: 500, color: "text.primary" }}>
            {item.label}
          </Typography>
          <ChevronRight sx={{ color: "text.disabled" }} />
        </ButtonBase>
      ))}
    </Box>
  );
};

export default ProfileMobileMenu;
